var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-card',{staticClass:"d-flex justify-center mb-3 mt-6",attrs:{"flat":"","tile":""}},[_vm._v(" IIP CMS Home ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }